import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_star = _resolveComponent("star")!
  const _component_post_count_chip = _resolveComponent("post-count-chip")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", null, [
    _createVNode(_component_router_link, {
      to: {name: 'client_profile', params: {clientId: _ctx.userClient.client.id}},
      class: "q-px-xs q-py-sm flex items-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_star, {
          "user-client": _ctx.userClient,
          class: "on-left"
        }, null, 8, ["user-client"]),
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.clientName(_ctx.userClient.client)) + " ", 1),
        _createVNode(_component_post_count_chip, {
          count: _ctx.totalUnreviewed,
          type: "unreviewed",
          size: "sm",
          outline: ""
        }, null, 8, ["count"]),
        _createVNode(_component_post_count_chip, {
          count: _ctx.totalEscalated,
          type: "escalated",
          size: "sm",
          outline: ""
        }, null, 8, ["count"])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}